export default "__VITE_ASSET__$86cE$HF__"